export default class RangeView {
    rangeEl;

    // Округленные до целого значения
    #currentPercentOfFill = 0;
    get currentPercentOfFill() {
        return this.#currentPercentOfFill;
    }

    currentValue;
    #endValue;

    constructor(rangeElId, currentValue, endValue) {
        this.rangeEl = document.getElementById(rangeElId);
        if (!this.rangeEl) return;

        this.currentValue = currentValue;
        this.#endValue = endValue;
    }

    update(percentOfFill, currentValue) {
        const roundedPercentOfFill = Math.round(percentOfFill * 10) / 10;

        if (roundedPercentOfFill !== this.#currentPercentOfFill) {
            this.#currentPercentOfFill = roundedPercentOfFill;
            this.updateCssVariable('--percent-of-fill', this.#currentPercentOfFill);
        }

        let roundedCurrentValue = Math.round(currentValue);

        if (!currentValue && this.#endValue) {
            roundedCurrentValue = Math.round(this.currentPercentOfFill * this.#endValue * 0.01);
        }

        if (roundedCurrentValue !== this.currentValue) {
            this.currentValue = roundedCurrentValue;
            this.updateCurrentValue();
        }
    }

    // eslint-disable-next-line
    updateCurrentValue() {}

    updateCssVariable(cssVarName, value) {
        this.rangeEl.style.setProperty(cssVarName, value);
    }
}
